import AbstractValueRow from "./AbstractValueRow.js";
import NaFormulaNode from "../../../keyFigure/formula/NaFormulaNode.js";
import percentage from "../../../../core/percentage.js";

/**
 * Formula report row.
 *
 * @param {formulNode} spec.formula - Formula of the row.
 * @param {boolean} [spec.formatInPercentage] - Whether data should be
 * formatted in percentage.
 * @param {string} spec.style - Style used to display the row.
 */
class FormulaRow extends AbstractValueRow {
	constructor({ formula, formatInPercentage, style } = {}) {
		super(...arguments);
		this._formula = formula;
		this._formatInPercentage = formatInPercentage;
		this._style = style;
	}

	getStyle() {
		return this._style;
	}

	getFormatter({ defaultFormatter, column }) {
		if (this._formatInPercentage) {
			if (column.isPercentageColumn()) {
				return () => "";
			}
			return percentage.forceTwoDecimals;
		}
		return defaultFormatter;
	}

	isFormulaRow() {
		return true;
	}

	accept(visitor) {
		return visitor.visitFormulaRow(this);
	}

	/**
	 * All formula nodes that reference template items are expanded to
	 * formulas.
	 *
	 * For example, an additionNode with a report reference will be replaced
	 * with an addition node with whatever the reference expands to (see
	 * implementations of `expandFormula()`).
	 */
	_asBaseFormulaNode() {
		if (this._template.hasRecursiveReference()) {
			// Avoid a stack overflow when the formula has a cycle:
			return new NaFormulaNode();
		}

		return this._formula.expandFormula(this._report);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		if (this._formula) {
			properties.expression = this.asFormulaNode();
		}

		properties.style = this.getStyle();

		return properties;
	}

	static getType() {
		return "ExpressionRow";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.formula = data.template && data.template.getFormula();
	}
}

export default FormulaRow;
